import Phaser from 'phaser';
import { Enemy } from './Enemy';
import type { EnemyConfig } from './Enemy';

export type AlienType = 'squid' | 'crab' | 'octopus';

export class ClassicAlien extends Enemy {
  private alienType: AlienType;
  private frameTime: number = 0;
  private currentFrame: number = 0;

  constructor(scene: Phaser.Scene, x: number, y: number, alienType: AlienType = 'crab') {
    const pointsByType = { squid: 30, crab: 20, octopus: 10 };
    
    const config: EnemyConfig = {
      texture: `alien_${alienType}`,
      points: pointsByType[alienType],
      health: 1,
      fireRate: 2000,
      projectileSpeed: 220,
      projectileTexture: 'alienLaser',
    };

    super(scene, x, y, config);
    this.alienType = alienType;
    
    // Set hitbox size
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setSize(28, 28);
    
    // Random starting frame
    this.currentFrame = Math.random() > 0.5 ? 0 : 1;
  }

  update(_time: number, delta: number): void {
    // Classic 2-frame animation (choppy like original)
    this.frameTime += delta;
    if (this.frameTime > 500) { // 500ms per frame like original
      this.frameTime = 0;
      this.currentFrame = this.currentFrame === 0 ? 1 : 0;
      // Toggle scale to simulate frame change (since we have single texture)
      this.scaleX = this.currentFrame === 0 ? 1 : -1;
    }
  }

  getAlienType(): AlienType {
    return this.alienType;
  }
}






